import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { getLocale, normalizeInternalLink } from '@/utils/localeSlug';

export function useNormalizedLink() {
  const { pathname } = useLocation();
  const locale = getLocale(pathname);
  const siteUrl = import.meta.env.VITE_DOMAIN;

  return useCallback(
    (url: string) => normalizeInternalLink(url, locale, siteUrl),
    [locale, siteUrl],
  );
}
